import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthErrors } from '../shared/enums/auth-errors';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
})
export class RedirectComponent implements OnInit, OnDestroy {
  redirect;
  count = 0;
  showMessage = false;
  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.redirect = setInterval(() => {
      this.countUp();
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.redirect);
  }

  countUp() {
    this.count++;
    if (this.count == 60) {
      this.showMessage = true;
      this.changeDetectorRef.detectChanges();
    }
    if (this.count == 120) {
      this.router.navigate(['/auth-error'], { queryParams: { error: AuthErrors.FailedRedirect } });
    }
  }
}
